import { render, staticRenderFns } from "./PreviousNameDate.vue?vue&type=template&id=7faf0fd7"
import script from "./PreviousNameDate.vue?vue&type=script&lang=js"
export * from "./PreviousNameDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports